// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/SpeedTestDropdown.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/SpeedTestDropdown.tsx");
  import.meta.hot.lastModified = "1732036225890.6108";
}
// REMIX HMR END

import * as Popover from "@radix-ui/react-popover";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
const options = [{
  label: "Mobile",
  value: "metrics:mobile"
}, {
  label: "Desktop",
  value: "metrics:desktop"
}];
export default function SpeedTestDropdown({
  onSelectOption
}) {
  _s();
  const [open, setOpen] = useState(false);
  return <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Trigger className="grow md:grow-0 font-medium focus:outline-none focus-visible:ring-2 bg-primary-800 text-white hover:bg-primary-600 transition-[background] duration-200 ease-in-out focus-visible:bg-primary-800 focus-visible:ring-primary-300 px-5 py-3 rounded-3xl shrink-0 flex gap-3 items-center">
        Performance <ChevronDownIcon className="ml-auto w-5 h-5" />
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content sideOffset={4} align="start" alignOffset={4} className={"data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2" + "!z-[9999] bg-white w-72 py-4 rounded-lg border border-primary-600 text-neutral-300"}>
          <ul className="space-y-3">
            {options.map(option => <li key={option.value}>
                <button type="button" className="text-neutral-600 w-full text-left px-4 hover:bg-neutral-100" onClick={() => {
              onSelectOption(option.value);
              setOpen(false);
            }}>
                  {option.label}
                </button>
              </li>)}
          </ul>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>;
}
_s(SpeedTestDropdown, "xG1TONbKtDWtdOTrXaTAsNhPg/Q=");
_c = SpeedTestDropdown;
var _c;
$RefreshReg$(_c, "SpeedTestDropdown");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;